import axios, { resHandle } from "@/plugins/axios";
/**
 * @description 登录
 */
const PostLogin = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/login/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            loading.close()
            reject();
        });
    });
};
/**
 * @description 退出登录
 */
const LoginOut = (vCom: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/logout/").then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            loading.close()
            reject();
        });
    });
};
/**
 * @description 获取当前用户信息
 */
const GetCurUserInfo = (vCom: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("/api/system/user/get_user_info/").then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 上传文件
 */
const UploadFile = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/system/file/", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取CRF模板列表的创建人列表
 */
const GetTemCreatorList = (vCom: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/system/user/list_all_for_admin/").then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取CRF模板翻页列表
 */
const GetTemList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/crf/template/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取CRF模板列表(不翻页)
 */
const GetTemData = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/crf/template/list_all/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新建CRF模板
 * (https://app.apifox.com/project/3858755/apis/api-151455982)
 * @param name 名称
 * @param category[] 分类,没有值要发空数组
 * @param system_type{} 系统类型，没有值要发空对象
 * @param assess_type{} 评估类型，没有值要发空对象
 * @param report_type{} 报告类型，没有值要发空对象
 * @param jifen_func{} 计分方式，没有值要发空对象
 */
const PostAddTem = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/crf/template/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 编辑CRF模板
 */
const PatchEditTem = (vCom: any, path: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.patch("api/crf/template/" + path + '/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取CRF模板详情
 * @param path(template的id)
 */
const GetTemDetail = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/crf/template/" + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除CRF模板
 */
const DelTem = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/crf/template/" + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 导入CRF模板
 * https://app.apifox.com/project/3858755
 * @param file
 */
const ImportTem = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/crf/template/import_data/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新建CRF组合
 * @param name 组合名称必填
 */
const PostAddGroup = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/crf/group/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 部分编辑CRF组合
 * @param path group的id
 */
const PatchEditGroup = (vCom: any, path: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.patch("api/crf/group/" + path + '/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取CRF组合翻页列表
 */
const GetGroupList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/crf/group/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取CRF组合列表（不翻页）
 */
const GetGroupData = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/crf/group/list_all/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取CRF组合详情
 * @param path group的id
 */
const GetGroupDetail = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("/api/crf/group/" + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除CRF组合
 * @param path id
 */
const DelGroup = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("/api/crf/group/" + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取CRF组合中的CRF模板列表
 * @param group(group的id)
 */
const GetGroupTemList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/crf/group_template/list_all/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 部分修改CRF组合中的CRF模板信息，如必填/非必填
 */
const PatchGroupTem = (vCom: any, path: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.patch("api/crf/group_template/" + path + '/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除CRF组合中的CRF模板
 */
const DelGroupTem = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/crf/group_template/" + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 对CRF组合中的CRF模板排序
 */
const PostSortGroupTem = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post(`api/crf/group/change_template_sort/`, params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新建CRF计划
 * @param name(访视计划名称)
 * @param related_type(关联类型)
 * @param group[](关联crf组合)
 */
const PostAddPlan = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/crf/plan/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 部分编辑CRF计划
 */
const PatchEditPlan = (vCom: any, path: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.patch("api/crf/plan/" + path + '/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取CRF计划翻页列表
 */
const GetPlanList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/crf/plan/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取CRF计划列表(不翻页)
 * @param is_suifanglei(true/false),发了只返回随访或非随访的数据，不需要过滤这个字段就不要发
 */
const GetPlanData = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/crf/plan/list_all/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取CRF计划详情
 */
const GetPlanDetail = (vCom: any, path: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/crf/plan/" + path + '/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除CRF计划
 */
const DelPlan = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/crf/plan/" + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 对CRF计划排序
 * @param plans[]
 */
const PostSortPlan = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/crf/plan/change_sort/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取CRF计划中CRF组合列表
 * @param plan(访视计划id)
 */
const GetPlanGroupList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/crf/plan_group/list_all/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 对某CRF计划中的CRF组合排序
 * @param plan_groups
 */
const PostSortPlanGroup = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/crf/plan/change_group_sort/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 分享CRF计划给部门或个人
 * https://app.apifox.com/project/3858755/apis/api-161027299
 * @param selected_list [{}]选中对象列表,id必填,type=user是人，type=dept是部门
 * @param plan {}分享的量表计划
 */
const PostSharePlan = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/share/share/crf_plan_to_user_dept/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取部门列表(不翻页)
 * https://app.apifox.com/project/3858755/apis/api-161786771
 * @param parent 查找子机构时发，这里只返回直属下级数据
 * @param id 获取某个机构详情时发
 */
const GetDeptData = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/system/dept/list_all/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取用户列表(不翻页)
 * https://app.apifox.com/project/3858755/apis/api-161786781
 * @param dept 需要查某个部门下的用户时需要发送部门id
 */
const GetUserList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/system/user/list_all/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};



/**
 * @description 搜索筛选返回打平的字典列表（计分方式、量表模板系统类型、量表模板类型）
 * @params values  字典value值列表，逗号分割
 */
const GetDictionaryData = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/all_flat_list/dictionary/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 一次性修改所有模版量表分类批量处理保存修改某类型的字典
 * @params parent_value  父级分类value
 * @params data  [{}]
 */
const PostDictionaryData = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/multi_update/dictionary/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取字典列表
 * https://app.apifox.com/project/3858755/apis/api-159637116
 */
const GetDictionary = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/system/dictionary/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新增字典选项
 * https://app.apifox.com/project/3858755/apis/api-148321976
 * @param value(必填)  
 * @param parent 父级
 * @param status  true/false
 */
const PostAddDictionary = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/system/dictionary/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 编辑字典选项
 * https://app.apifox.com/project/3858755/apis/api-148321976
 * @param value(必填)  
 * @param parent 父级
 * @param status  true/false
 */
const PatchEditDictionary = (vCom: any, path: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.patch('api/system/dictionary/' + path + '/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除字典选项
 * https://app.apifox.com/project/3858755/apis/api-159637116
 * @param path id
 */
const DelDictionary = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete('api/system/dictionary/' + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取某个plan下的所有templates量表计划
 */
const GetPlanTem = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/crf/plan/" + path + '/all_templates_in_plan/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 量表导出管理
 * @url https://app.apifox.com/link/project/3858755/apis/api-223508373
 * @api /api/crf/export_management/
 */
const PostAddBingzhong = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/crf/export_management/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 量表导出管理-编辑
 * @url https://app.apifox.com/link/project/3858755/apis/api-223508382
 * @api /api/crf/export_management/{id}/
 */
const PatchBingzhong = (vCom: any, path: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.patch("api/crf/export_management/" + path + '/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 量表导出模版
 * @url https://app.apifox.com/link/project/3858755/apis/api-223203027
 * @api /api/crf/export_management/
 * @param plan 量表计划{},里面有id就行
 * @param headers 导出表头[{key:'',title:'',origin:''}]
 * @param time_key 导出时间key
 */
const PostAddBingzhongTem = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/crf/export_template/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 量表导出模版-编辑
 * @url https://app.apifox.com/link/project/3858755/apis/api-223203036
 * @api /api/crf/export_management/
 * @param plan 量表计划{},里面有id就行
 * @param headers 导出表头[{key:'',title:'',origin:''}]
 * @param time_key 导出时间key
 */
const PatchBingzhongTem = (vCom: any, path: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.patch("api/crf/export_template/" + path + '/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 返回全部数据列表-量表导出管理
 * @url https://app.apifox.com/link/project/3858755/apis/api-223508377
 * @api /api/crf/export_management/list_all/
 */
const GetExportManagementAll = (vCom: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/crf/export_management/list_all/").then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除量表导出管理
 * @url https://app.apifox.com/link/project/3858755/apis/api-223508383
 * @api /api/crf/export_management/{id}/
 */
const DeleteExportManagement = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/crf/export_management/" + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取详情量表导出模版
 * @url https://app.apifox.com/link/project/3858755/apis/api-223203034
 * @api /api/crf/export_template/{id}/
 */
const GetExportTem = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/crf/export_template/" + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};

export {
    PostLogin, LoginOut, GetCurUserInfo, GetUserList,
    GetTemCreatorList,
    UploadFile,
    GetTemList, GetTemData, PostAddTem, PatchEditTem, GetTemDetail, DelTem, ImportTem,
    PostAddGroup, PatchEditGroup, GetGroupList, GetGroupData, GetGroupDetail, DelGroup,
    GetGroupTemList, PatchGroupTem, DelGroupTem, PostSortGroupTem,
    PostAddPlan, PatchEditPlan, GetPlanList, GetPlanData, GetPlanDetail, DelPlan, PostSortPlan, GetPlanTem,
    GetPlanGroupList, PostSortPlanGroup,
    PostSharePlan,
    GetDeptData,
    GetDictionaryData, PostDictionaryData, GetDictionary, PostAddDictionary, PatchEditDictionary, DelDictionary,
    PostAddBingzhong, PatchBingzhong, PostAddBingzhongTem, PatchBingzhongTem,
    GetExportManagementAll, DeleteExportManagement, GetExportTem
}